<template>
  <div class="feedbacks-list">
    <feedback-item
      v-for="feedback in feedbacks"
      :key="feedback.id"
      :feedback="feedback"
      class="mb-2"
    />
  </div>
</template>

<script>
import FeedbackItem from './FeedbackItem.vue'

export default {
  name: 'FeedbacksList',

  props: {
    feedbacks: {
      type: Array,
      default: () => ([])
    }
  },

  components: {
    FeedbackItem
  }
}
</script>
